import { useContext } from "react";
import { RouterContext } from "@contexts/router";

export const useRouterContext = () => {
  const { useHistory, useLocation, useParams, useBlocker, Prompt, Link } =
    useContext(RouterContext);

  return {
    useHistory,
    useLocation,
    useParams,
    useBlocker,
    Prompt,
    Link,
  };
};
